import Dashboard from './index';

export default { path: '/home/dashboard', component: Dashboard };
